import AIVolatilityMessageSettings from "../components/page/AIVolatilityMessageSettings";

const AIVolatilityMessageEditPage = () => {
  return (
      <AIVolatilityMessageSettings />
  );
};
export default AIVolatilityMessageEditPage;
